// extracted by mini-css-extract-plugin
export default {"main":"PinCode_main__HFphv","body":"PinCode_body__-bsfd","list":"PinCode_list__VZnI-","btn":"PinCode_btn__C+Kg1","header":"PinCode_header__3IBLn"};